import { reactive } from 'vue'
import messages from './messages'

const STORAGE_KEY = 'dk_locale'

function detectLocale() {
  const saved = window.localStorage.getItem(STORAGE_KEY)
  if (saved === 'zh' || saved === 'en') return saved
  return navigator.language && navigator.language.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

export const localeState = reactive({
  locale: typeof window !== 'undefined' ? detectLocale() : 'zh',
})

export function t(key, params = {}) {
  const dict = messages[localeState.locale] || messages.zh
  let text = dict[key] ?? messages.zh[key] ?? key
  Object.keys(params).forEach(name => {
    text = text.replace(new RegExp(`\\{${name}\\}`, 'g'), String(params[name]))
  })
  return text
}

export function setLocale(locale) {
  if (locale !== 'zh' && locale !== 'en') return
  localeState.locale = locale
  window.localStorage.setItem(STORAGE_KEY, locale)
  document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en'
  document.title = t('doc.title')
  const meta = document.querySelector('meta[name="description"]')
  if (meta) meta.setAttribute('content', t('doc.description'))
}

export function toggleLocale() {
  setLocale(localeState.locale === 'zh' ? 'en' : 'zh')
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = localeState.locale === 'zh' ? 'zh-CN' : 'en'
  document.title = t('doc.title')
  const meta = document.querySelector('meta[name="description"]')
  if (meta) meta.setAttribute('content', t('doc.description'))
}
